import dateFormat from "date-format";
const Advertising = () =>
	import(
		/* webpackChunkName: "component-advertising" */ "@/components/advertising"
	);
import Header from "@/components/template-components/header";
const Footer = () =>
	import(
		/* webpackChunkName: "component-footer" */ "@/components/template-components/footer"
	);
import { PAGES, AD_LAYOUT_STUBS } from "@/common/consts";
import { mapGetters, mapState } from "vuex";

import { created, mounted, destroyed } from "./hooks";

/**
 * MAIN APP
 *
 * This App Component provides the basic layout page for all WF.
 *
 * TODO: ./styles.scss aren't scoped and they SHOULD provide proper page layouts
 * (something like .page.full-width, page.with-sidebar; or alike) and also
 * generic Heading styles to be consistently used across components.
 */
export default {
	name: "App",
	data() {
		return {
			AD_LAYOUT_STUBS,
			headerHeight: null,
			windowHeight: null,
			windowWidth: null,
		};
	},
	computed: {
		...mapGetters(["isDialogOpen"]),
		...mapGetters("device", ["isSmallDevice", "isMediumDeviceOrWider"]),
		...mapState({
			features: (state) => state.features,
		}),
		classNames() {
			let c = [];

			if (this.$store.state.navigation.current == PAGES.NOT_FOUND) {
				c.push("page-not-found");
			}

			return c;
		},
		adhesionAdStub() {
			return this.$route.name === PAGES.UNSCRAMBLER_RESULTS
				? AD_LAYOUT_STUBS.ADHESION_RESULTS
				: AD_LAYOUT_STUBS.ADHESION;
		},
		shouldAdhesionAdVerticallyAlign() {
			return this.adhesionAdStub === AD_LAYOUT_STUBS.ADHESION_RESULTS;
		},
		showAdhesionAd() {
			if (
				this.windowHeight !== null &&
				this.windowHeight < 500 &&
				this.isSmallDevice
			) {
				return false;
			}

			if (this.$route.name === PAGES.SAVED_WORDS) {
				return false;
			}

			return true;
		},
		/**
		 * We want to hide the ads on specific landing pages.
		 */
		showAd() {
			if (
				this.$route.name === PAGES.ARTICLE_DETAIL &&
				this.$store.state.hideArticleAds
			) {
				return false;
			}

			return true;
		},
		isHomeOrLandingPages() {
			switch (this.$route.name) {
				case PAGES.HOME:
				case PAGES.SCRABBLE_DICT:
				case PAGES.WWF:
				case PAGES.FOURPICS:
				case PAGES.ANAGRAM:
				case PAGES.WORD_MAKER:
				case PAGES.JUMBLE_SOLVER:
				case PAGES.UNSCRAMBLE:
				case PAGES.LETTERS_AND_BLANK:
				case PAGES.WORD_CHUMS_CHEAT:
				case PAGES.WORDBRAIN_ANSWERS:
				case PAGES.WORDCOOKIES:
				case PAGES.WORDFEUD:
				case PAGES.WORD_DESCRAMBLER:
				case PAGES.SCRABBLE_CHECKER:
				case PAGES.TEXT_TWIST:
				case PAGES.CODY_CROSS:
				case PAGES.WORD_SWIPE_CHEATS:
				case PAGES.WORD_STORY:
				case PAGES.WORD_CONNECT:
				case PAGES.WORDLE:
					return true;
				default:
					return false;
			}
		},
	},
	components: {
		Advertising,
		Header,
		Footer,
	},
	methods: {
		onWindowResize() {
			this.windowHeight =
				window.innerHeight ||
				document.documentElement.clientHeight ||
				document.body.clientHeight;
			this.windowWidth =
				window.innerWidth ||
				document.documentElement.clientWidth ||
				document.body.clientWidth;
			this.$store.commit("device/UPDATE_WINDOW_PROPERTIES", {
				windowHeight: this.windowHeight,
				windowWidth: this.windowWidth,
			});
		},
		onWindowScroll() {
			this.$store.commit(
				"device/UPDATE_WINDOW_SCROLL",
				window.pageYOffset
			);
		},
		checkLastVisited() {
			const lastVisitedTime = window.$cookies.get("last_visited");
			this.$store.commit("updateLastVisited", lastVisitedTime);
			this.setLastVisited();
		},
		setLastVisited() {
			const currentTime = dateFormat(
				dateFormat.ISO8601_WITH_TZ_OFFSET_FORMAT
			);
			window.$cookies.set("last_visited", currentTime, "7d");
		},
		detectAdBlocker() {
			//Detect adblocker scripts.
			if (
				typeof window.__PRERENDER_INJECTED === "undefined" &&
				typeof window.__TEST__ === "undefined"
			) {
				var test = document.createElement("div");
				test.innerHTML = "&nbsp;";
				test.className = "adsbox";
				document.body.appendChild(test);
				window.setTimeout(() => {
					if (test.offsetHeight === 0) {
						this.$el.classList.add("is-blocking-ads");
					}
					test.remove();
				}, 100);
			} else if (typeof window.__TEST__ !== "undefined") {
				// In testing mode we always want it to adblock.
				this.$el.classList.add("is-blocking-ads");
			}
		},
	},
	mounted,
	created,
	destroyed,
};
